import SwitchWidget from 'components/Widgets/Switch';

const SwitchTypeField = ({ selectItem, setNewSelectItem, item, disabled, forTable }) => {
  if (forTable && item.value !== '') {
    return (
      <SwitchWidget
        selected={item.value === true || item.value === 'true' || item === true || item === 'true'}
        item={item}
        disabled={true}
      />
    );
  } else {
    return (
      <SwitchWidget
        selected={
          selectItem?.value !== '' && selectItem?.value ? selectItem?.value === 'true' : false
        }
        onChange={(val) => {
          setNewSelectItem({
            value: `${!!val.value}`,
          });
        }}
        item={item}
        disabled={disabled}
      />
    );
  }
};

export default SwitchTypeField;
